import React, { ReactNode, useEffect, useState } from 'react';
import { Button } from '../../../../../base/components/Button';
import { Modal } from '../../../../../base/components/Modal';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { Area } from '../../../../../base/interfaces/config';
import { __t } from '../../../../../base/utils/t';
import { AreasSelect } from '../../../../components/AreasSelect';
import { profileActions } from '../../redux/slice/profileSlice';

interface Props {
    children: ReactNode;
}

export const RecruiterProfileAreasSelect = ({ children }: Props) => {
    const dispatch = useAppDispatch();
    const {
        recruiterAppProfile: {
            fields: { areas: selectedAreas },
        },
        recruiterApp: {
            config: { areas },
        },
    } = useAppSelector((state) => state);

    const [showModal, setShowModal] = useState(false);
    const [selectedAreasBeforeSave, setSelectedAreasBeforeSave] = useState<Area[]>([]);

    useEffect(() => {
        setSelectedAreasBeforeSave(selectedAreas);
    }, [selectedAreas]);

    const inputChangeHandler = (value: Area[]) => setSelectedAreasBeforeSave(value);

    const saveHandler = () => {
        dispatch(profileActions.setField({ id: 'areas', value: selectedAreasBeforeSave }));
        setShowModal(false);
    };

    const closeModalHandler = () => {
        setSelectedAreasBeforeSave(selectedAreas);
        setShowModal(false);
    };

    return (
        <>
            <div onClick={() => setShowModal(true)}>{children}</div>
            <Modal
                visible={showModal}
                visibilityHandler={closeModalHandler}
                className='recruiter-profile-form__modal'
                containerClassName='recruiter-profile-form__modal-container'
            >
                <AreasSelect
                    title={__t('В какие сферы трудоустраиваете работников?')}
                    className='recruiter-profile-form__modal-select'
                    areas={areas}
                    selectedAreas={selectedAreasBeforeSave}
                    selectHandler={inputChangeHandler}
                />
                <div className='recruiter-profile-form__modal-buttons'>
                    <Button className='recruiter-profile-form__modal-button' onClick={saveHandler}>
                        {__t('Сохранить')}
                    </Button>
                    <Button className='recruiter-profile-form__modal-button' type='link' onClick={closeModalHandler}>
                        {__t('Отмена')}
                    </Button>
                </div>
            </Modal>
        </>
    );
};
